export const buildCompanyUrlCriteria = (url) => ({
  url
});

export const buildCompanyStatusCriteria = (status = "ACTIVE") => ({
  status
});

export const buildEmptyCriteria = () => ({});
